<script>
  import PageContent from "@/components/PageContent";
  import { HeadMeta } from "@/utils/head-meta";

  export default {
    components: {
      PageContent,
    },
    scrollToTop: true,
    async asyncData ({ app, params, error }) {
      try {
        const end = new Date("05/08/2026 06:01 AM");
        const now = new Date();
        const distance = end - now;
        const days = Math.ceil(distance / (1000 * 60 * 60 * 24));
        let { items } = await app.$contentful.getEntries({
          content_type: "page",
          "fields.slug": params.slug,
          include: 4,
        });
        items = items.map((item) => {
          if (item.fields.title && typeof item.fields.title === "string") {
            item.fields.title = item.fields.title.replace("{daysLeft}", days);
          }
          return item;
        });
        const currentPage = items.filter((item) => !item.fields.parentPage);
        if (!items.length || !currentPage[0] || currentPage.length > 1)
        {error({ statusCode: 404, message: "This page could not be found" });}
        return {
          page: currentPage[0],
        };
      } catch (e) {
        error(e);
      }
    },
    head () {
      return HeadMeta(this.page.fields);
    },
  };
</script>

<template>
  <page-content :page="page" />
</template>
